import { Toaster as SonnerToaster, toast } from 'sonner';
import { useTheme } from '@/lib/theme';

export { toast };

/**
 * Sonner con nuestros tokens. Se estilan las clases por `toastOptions` en vez
 * de por CSS global para que el tema oscuro salga de las mismas variables que
 * el resto de la interfaz.
 */
export function Toaster() {
  const { scheme } = useTheme();
  return (
    <SonnerToaster
      theme={scheme}
      position="bottom-right"
      closeButton
      richColors={false}
      toastOptions={{
        classNames: {
          toast:
            'group !bg-surface-raised !text-fg !border !border-border !shadow-lg !rounded-lg !font-sans',
          title: '!text-sm !font-semibold !text-fg',
          description: '!text-xs !text-fg-muted',
          actionButton: '!bg-primary !text-primary-fg !rounded-md !text-xs',
          cancelButton: '!bg-surface-sunken !text-fg-muted !rounded-md !text-xs',
          closeButton: '!bg-surface !border-border !text-fg-muted',
          success: '!border-success-border [&_[data-icon]]:!text-success',
          error: '!border-danger-border [&_[data-icon]]:!text-danger',
          warning: '!border-warning-border [&_[data-icon]]:!text-warning',
          info: '!border-info-border [&_[data-icon]]:!text-info',
        },
      }}
    />
  );
}
